import { render, staticRenderFns } from "./MessageDrawer.vue?vue&type=template&id=084ab2ad&scoped=true"
import script from "./MessageDrawer.vue?vue&type=script&lang=js"
export * from "./MessageDrawer.vue?vue&type=script&lang=js"
import style0 from "./MessageDrawer.vue?vue&type=style&index=0&id=084ab2ad&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ab2ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('084ab2ad')) {
      api.createRecord('084ab2ad', component.options)
    } else {
      api.reload('084ab2ad', component.options)
    }
    module.hot.accept("./MessageDrawer.vue?vue&type=template&id=084ab2ad&scoped=true", function () {
      api.rerender('084ab2ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/loyout/components/MessageDrawer.vue"
export default component.exports